const initializeSlider = (sliderContainer) => {
    const slider = sliderContainer.querySelector('.slider');
    const slides = slider.querySelectorAll('.slider__element');
    const navigation = sliderContainer.querySelector('.slider__navigation');
    const prevArrow = sliderContainer.querySelector('.arrow-slider.left');
    const nextArrow = sliderContainer.querySelector('.arrow-slider.right');

    let currentIndex = 0;
    const totalSlides = slides.length;
    const slidesToShow = parseInt(getComputedStyle(sliderContainer).getPropertyValue('--slides-to-show')) || 1;

    // Calcular el número de puntos de navegación necesarios
    const dotsCount = totalSlides - slidesToShow + 1;

    // Generar los puntos de navegación si es necesario
    if (dotsCount > 1) {
        for (let i = 0; i < dotsCount; i++) {
            const li = document.createElement('li');
            if (i === currentIndex) li.classList.add('active');
            navigation.appendChild(li);
        }
    } else {
        navigation.style.display = 'none'; // Ocultar navegación si no es necesaria
    }

    const updateNavigation = () => {
        const dots = navigation.querySelectorAll('li');
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
        });
    };

    const updateSliderPosition = () => {
        slider.style.transform = `translateX(-${currentIndex * (100 / slidesToShow)}%)`;
    };

    const updateArrowsVisibility = () => {
        // Mostrar las flechas solo si hay más diapositivas que las que se muestran
        if (totalSlides > slidesToShow) {
            prevArrow.style.display = currentIndex > 0 ? 'block' : 'none';
            nextArrow.style.display = currentIndex < dotsCount - 1 ? 'block' : 'none';
        } else {
            prevArrow.style.display = 'none';
            nextArrow.style.display = 'none';
        }
    };

    const updateContainerHeight = () => {
    // Solo se ajusta la altura cuando se muestra una diapositiva a la vez
    if (slidesToShow === 1) {
        const currentSlideHeight = slides[currentIndex].offsetHeight;
        sliderContainer.style.height = `${currentSlideHeight + 20}px`; // Altura de slider-container
        slider.style.height = `${currentSlideHeight}px`; // Altura de slider
    }
};

    nextArrow.addEventListener('click', () => {
        if (currentIndex < dotsCount - 1) {
            currentIndex++;
            updateSliderPosition();
            updateNavigation();
            updateArrowsVisibility();
            updateContainerHeight(); // Actualizar altura al cambiar diapositiva
        }
    });

    prevArrow.addEventListener('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            updateSliderPosition();
            updateNavigation();
            updateArrowsVisibility();
            updateContainerHeight(); // Actualizar altura al cambiar diapositiva
        }
    });

    navigation.addEventListener('click', (e) => {
        if (e.target.tagName === 'LI') {
            currentIndex = Array.from(navigation.children).indexOf(e.target);
            updateSliderPosition();
            updateNavigation();
            updateArrowsVisibility();
            updateContainerHeight(); // Actualizar altura al cambiar diapositiva
        }
    });

    // Variables para controlar el deslizamiento
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let isScrollingVertically = false;

    // Función para detectar el movimiento horizontal o vertical
    const getPositionX = (event) => event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    const getPositionY = (event) => event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;

    const touchStart = (event) => {
        isDragging = true;
        startPos = getPositionX(event);
        startY = getPositionY(event);  // Guardar la posición inicial vertical
        slider.style.transition = 'none';
        isScrollingVertically = false;
    };

    const touchMove = (event) => {
        if (!isDragging) return;

        const currentPositionX = getPositionX(event);
        const currentPositionY = getPositionY(event);
        
        // Detectar si el movimiento es más vertical que horizontal
        if (Math.abs(currentPositionY - startY) > Math.abs(currentPositionX - startPos)) {
            isScrollingVertically = true; // Establecer como desplazamiento vertical
        }

        if (!isScrollingVertically) {
            // Desplazamiento horizontal solo si no estamos en el primer o último slide
            if (currentIndex === 0 && currentPositionX > startPos) return; // Bloquear al principio
            if (currentIndex === dotsCount - 1 && currentPositionX < startPos) return; // Bloquear al final

            currentTranslate = prevTranslate + currentPositionX - startPos;
            slider.style.transform = `translateX(${currentTranslate}px)`;
        }
    };

    const touchEnd = () => {
        isDragging = false;
        if (!isScrollingVertically) {
            const movedBy = currentTranslate - prevTranslate;
            if (movedBy < -50 && currentIndex < dotsCount - 1) currentIndex++;
            if (movedBy > 50 && currentIndex > 0) currentIndex--;
            setPositionByIndex();
        }
    };

    const setPositionByIndex = () => {
        currentTranslate = currentIndex * -(100 / slidesToShow) * sliderContainer.offsetWidth / 100;
        prevTranslate = currentTranslate;
        slider.style.transition = 'transform 0.5s ease-in-out';
        slider.style.transform = `translateX(-${currentIndex * (100 / slidesToShow)}%)`;
        updateNavigation();
        updateArrowsVisibility();
        updateContainerHeight(); // Actualizar altura al cambiar diapositiva
    };

    slider.addEventListener('mousedown', touchStart);
    slider.addEventListener('mousemove', touchMove);
    slider.addEventListener('mouseup', touchEnd);
    slider.addEventListener('mouseleave', () => {
        if (isDragging) touchEnd();
    });

    slider.addEventListener('touchstart', touchStart);
    slider.addEventListener('touchmove', touchMove);
    slider.addEventListener('touchend', touchEnd);

    // Inicialización de visibilidad de flechas y navegación
    updateArrowsVisibility();
    updateContainerHeight(); // Asegurar que la altura inicial sea correcta
};

// Inicializar todos los sliders con la clase "slider-container"
document.querySelectorAll('.slider-container').forEach(initializeSlider);